module.exports = __webpack_public_path__ + "img/apple-logo.f5debb49.svg";